import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.analysis;

export default class Analysis extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(),
      trial_id: this.number(null),
      unique_id: this.string(''),
      name: this.string(''),
      temperature: this.attr(''),
      day: this.attr(0),
      start_date: this.string(''),
      type_of_analysis: this.attr(null),
      laboratory: this.attr(null),
      analysis: this.attr(null),
      amount: this.number(0),
      product_code: this.attr(''),
      product_unique_id: this.attr(''),
      workdate: this.attr(''),
      status: this.attr('HOLD'),
      status_notes: this.attr(''),
      trial: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/analysis',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/',
          method: 'get',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/:id/by_list/',
          method: 'patch',
        },
      },
    },
  };
}
